// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconLightBulb = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M32 6C19.6682 6 12 13.6429 12 25.975C12 34.9175 16.5095 38.258 20 42.2141V50C20 51.2341 20.7659 52 22 52H24V56C24 57.2341 24.7659 58 26 58H38C39.2341 58 40 57.2341 40 56V52H42C43.2341 52 44 51.2341 44 50V42.4043C47.4858 38.7169 51.9862 35.7582 51.9862 26.644C51.9862 14.3119 44.3318 6 32 6ZM41 27.2188C41 28.1443 40.4255 28.7188 39.5 28.7188C39.0063 28.7188 38.0393 28.5629 36.4546 28.4315C35.1406 28.3225 34.2678 29.1465 34.2944 30.4648C34.4259 36.9811 34.8125 39.7932 34.8125 40.5C34.8125 41.4256 34.238 42 33.3125 42H30.6875C29.762 42 29.1875 41.4256 29.1875 40.5C29.1875 39.7932 29.5742 36.9811 29.7056 30.4648C29.7322 29.1465 28.8594 28.3225 27.5454 28.4315C25.9608 28.5629 24.9937 28.7188 24.5 28.7188C23.5745 28.7188 23 28.1443 23 27.2188V24.7812C23 23.8557 23.5745 23.2812 24.5 23.2812C25.3516 23.2812 27.575 23.75 32 23.75C36.425 23.75 38.6484 23.2812 39.5 23.2812C40.4255 23.2812 41 23.8557 41 24.7812V27.2188Z" />
    </svg>
  );
};
